import { configureStore } from "@reduxjs/toolkit";
import membersReducer from "./redux/members";
import authReducer from "./redux/auth";


export const store = configureStore({
    reducer: {
        members : membersReducer,
        auth : authReducer
    },
    middleware : (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
        });
    }
})

window.store = store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;